
import { IonCheckbox, IonItem, IonLabel } from '@ionic/react';
import { createUseStyles } from 'react-jss';
import { RequiredTrigger } from './RequiredTrigger';

const useStyles = createUseStyles(() => ({
    checkbox: {
        pointerEvents: 'none',
        '&::part(mark)': {
            strokeWidth: 2
        }
    }
}));

interface ICheckboxGroupProps<T> {
    options: {label: string, value: T, key?: string}[];
    value: T;
    required?: boolean;
    onChange: (value: T) => void;
}

export const RadioGroup = <T,>({ options, value, required, onChange }: ICheckboxGroupProps<T>) => {
    const classes = useStyles();

    const handleClick = (newValue: T) => {
        onChange(newValue);
    };

    return (
        <>
            {options.map(option => (
                <div key={option.key || String(option.value)}>
                    <IonItem lines="none" style={{marginTop: -5, '--padding-start': '2px', '--padding-end': 0}} onClick={() => handleClick(option.value)}>
                        <IonCheckbox mode="ios" class={classes.checkbox} checked={value === option.value} />
                        <IonLabel style={{marginLeft: 3}}>{option.label}</IonLabel>
                    </IonItem>
                </div>
            ))}

            {required &&
                <RequiredTrigger value={value} />
            }
        </>
    );
};
